/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TeamSearchFilterPayload { 
    text_search?: string | null;
    competition_ids?: Array<number> | null;
    category_ids?: Array<number> | null;
    genders?: Array<number> | null;
    season_id?: number | null;
    is_ia_search?: boolean;
    page?: number;
    page_size?: number;
}

